import React from 'react';
import { HVAConversationProvider } from './HVAProductAndOrdersContext';
import HVADynamicConversationModalContent from './HVAProductAndOrdersModalContent';
import { HVADynamicConversationModalProps } from './HVAProductAndOrdersData';

const HVAProductAndOrdersModal: React.FC<
  HVADynamicConversationModalProps
> = props => {
  return (
    <HVAConversationProvider>
      <HVADynamicConversationModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVAProductAndOrdersModal;
